function getUnusedSize() {
  let maxByteSize = 10485760; // 10MB
  let minByteSize = 0;
  let tryByteSize = 0;
  let testQuotaKey = 'testQuota';
  let timeout = 20000;
  let startTime = new Date().getTime();
  let unusedSpace = 0;
  let runtime;
  do {
    runtime = new Date().getTime() - startTime;
    try {
      tryByteSize = Math.floor((maxByteSize + minByteSize) / 2);
      localStorage.setItem(testQuotaKey, String('1').repeat(tryByteSize));
      minByteSize = tryByteSize;
    } catch (e) {
      maxByteSize = tryByteSize - 1;
    }
  } while (maxByteSize - minByteSize > 1 && runtime < timeout);

  localStorage.removeItem(testQuotaKey);

  if (runtime >= timeout) {
    console.log('Unused space calculation may be off due to timeout.');
  }

  // Compensate for the byte size of the key that was used, then subtract 1 byte because the last value of the tryByteSize threw the exception
  unusedSpace = tryByteSize + testQuotaKey.length - 1;
  return unusedSpace / 1024;
}

function getUsedSizes() {
  let total = 0;
  let objects = [];

  for (let key in localStorage) {
    if (!localStorage.hasOwnProperty(key)) {
      continue;
    }
    const valueLength = localStorage[key].length + key.length;
    const keyLength = key.length;
    const valueAndKeyLength = valueLength + keyLength;
    total += valueAndKeyLength;
    objects.push({
      key: key.substring(0, 50),
      value: localStorage[key].substring(0, 1000) + '...',
      sizeKB: valueAndKeyLength / 1024,
    });
  }

  objects = objects.sort((a, b) => (a.sizeKB > b.sizeKB ? -1 : 1));
  return { objects, totalKB: total / 1024 };
}

export function getLocalstorageSizes() {
  const { objects, totalKB } = getUsedSizes();
  const unused = getUnusedSize();

  return { objects, usedTotalKB: totalKB, remainingTotalKB: unused };
}
